import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Global FlowForge hover card: any element with title="" or data-tip="" shows a themed card at the cursor (portaled to <body> so it sits above every layer).
export default function HoverCardLayer() {
  const [tip, setTip] = useState(null);
  useEffect(() => {
    let cur = null;
    const strip = (el) => { const t = el.getAttribute("title"); if (t) el.setAttribute("data-tip", t); el.removeAttribute("title"); };
    const over = (e) => {
      const el = e.target.closest?.("[title],[data-tip]");
      if (!el) { cur = null; setTip(null); return; }
      if (el.hasAttribute("title")) strip(el);
      cur = el;
      const text = el.getAttribute("data-tip");
      setTip(text ? { text, x: e.clientX, y: e.clientY } : null);
    };
    const move = (e) => { if (!cur) return; if (cur.hasAttribute("title")) strip(cur); setTip((t) => t && { ...t, x: e.clientX, y: e.clientY }); };
    const out = (e) => { if (cur && !cur.contains(e.relatedTarget)) { cur = null; setTip(null); } };
    const hide = () => { cur = null; setTip(null); };
    document.addEventListener("mouseover", over);
    document.addEventListener("mousemove", move);
    document.addEventListener("mouseout", out);
    document.addEventListener("mousedown", hide);
    return () => { document.removeEventListener("mouseover", over); document.removeEventListener("mousemove", move); document.removeEventListener("mouseout", out); document.removeEventListener("mousedown", hide); };
  }, []);
  if (!tip) return null;
  const left = Math.min(tip.x + 14, window.innerWidth - 300);
  const top = tip.y + 18 > window.innerHeight - 60 ? tip.y - 44 : tip.y + 18;
  return createPortal(
    <div data-testid="hover-card" style={{ left, top, zIndex: 2147483647 }}
      className="fixed pointer-events-none max-w-[280px] px-3 py-2 rounded-md border border-[#F59E0B]/60 bg-[#0B111D]/95 backdrop-blur-md shadow-[0_8px_30px_rgba(0,0,0,0.5)] text-xs text-[#E5E7EB] font-medium">
      <span className="block h-0.5 w-6 mb-1.5 bg-[#F59E0B]" />{tip.text}
    </div>,
    document.body,
  );
}
